import { render, staticRenderFns } from "./upsell_form.vue?vue&type=template&id=682c395c&"
import script from "./upsell_form.vue?vue&type=script&lang=js&"
export * from "./upsell_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports